import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

export async function postContactLead(payload) {
  const res = await api.post("/leads/contact", payload);
  return res.data;
}

export async function postRfqLead(payload) {
  const res = await api.post("/leads/rfq", payload);
  return res.data;
}
